import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { ButtonGroup, Button, Module, Row, Col } from 'components/misc'
import { FormattedMessage } from 'react-intl'
import styles from './bulk-change-panel.styl'

export default class BulkChangePanel extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    onBulkChange: PropTypes.func.isRequired,
    onClearSelection: PropTypes.func.isRequired,
    selectedCount: PropTypes.number.isRequired
  }

  render() {
    const {
      children,
      selectedCount,
      onClearSelection,
      onBulkChange
    } = this.props

    return (
      <Module verticallyNarrowExtra primary>
        <Row alignItems="center" gutters inner>

          {children}

          <Col flex="1 1 auto" alignSelf="center" right>
            <div className={styles.controlContainer}>
              {selectedCount > 0 && (
                <div className={styles.count}>
                  <FormattedMessage
                    id="label.count_items_selected"
                    defaultMessage="{count} items selected"
                    values={{
                      count: selectedCount
                    }}
                  />
                </div>
              )}

              <ButtonGroup right>
                {selectedCount && (
                  <Button
                    type="button"
                    intlKey="button.clear"
                    secondary
                    onClick={onClearSelection}
                  >
                    Clear
                  </Button>
                )}
                <Button type="button"
                        intlKey="button.bulk_change"
                        disabled={!selectedCount}
                        onClick={onBulkChange}>
                  Bulk change
                </Button>
              </ButtonGroup>
            </div>
          </Col>
        </Row>
      </Module>
    )
  }
}
